import { FC } from "react";
import { useMap } from "react-leaflet";

interface ChangeViewProps {
  center: any;
  zoom?: number;
}

const ChangeView: FC<ChangeViewProps> = ({ center, zoom }) => {
  const map = useMap();
 // map.setView(center, zoom);
 map.flyTo(center, zoom, {
  animate: true,
  duration: 0.9,
});
  return null;
};

export default ChangeView;
